var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-scrollbar',{attrs:{"wrap-class":"scrollbar-wrapper"}},[_c('div',{staticClass:"root-logo",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.$router.push({ name: 'index' })}}},[_c('img',{attrs:{"alt":"3306","src":require("../../../assets/images/logo_white.png")}})]),_c('menuu',{attrs:{"items":_vm.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }